import { IFlags } from 'domain/store/FlagsModel';
import { useStore } from 'hooks/useStore';

export function useFlags(): IFlags {
  const { flags } = useStore();

  return flags;
}
